<template>
  <TransactionListTemplate
    :screen-config="setScreenConfig"
    :row-click="rowClickCallBack"
    persistence-key="exception-list"
    :setLoading="setLoading"
    ref="exception-list"
  >
    <template #popup>
      <gcPopupShiftException
        :popupConfig="shiftExceptionPopupConfig"
        :data-model="dataModel"
        :on-hide="onShiftsPopupHide"
        v-if="shiftExceptionPopupConfig.isPopupShow"
        :displayServerError="displayServerErrorOnTemplate"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import {
  GetIndexByTabName,
  ProcessCapacityTabs,
} from "../../../_models/tabdata/production/process-capacity";

import gcPopupShiftException from "../../../popups/production/gc-popup-shift-exception.vue";
import { FeatureStorage } from "../../../_services/storage";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";
import { ProcessCapacityService } from "../../../_services/api/production/process-capacity.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    gcPopupShiftException,
  },
  data() {
    return {
      setLoading: false,
      dataModel: undefined,
      shiftExceptionPopupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
      },
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Exception List",
        ScreenName: "Exception List",
        exportFileName: "Exception List",
        selectedIndex: GetIndexByTabName("Exceptions"),
        tabs: ProcessCapacityTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ExceptionList",
              serverPaging: true,
              allowGrouping: false,
              keyType: {
                ...this.getAttributeKeyTypes(),
              },
              postProcessCallback: this.postProcessCallback,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Exception List",
                message: "Get Started, Add an Exception",
              },
            },
            // options: {
            //   selectionMode: "multiple",
            // },
          },
          toolbar: {
            screenName: "Exception List",
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: () => {
                  this.onNewShiftExceptionHandler();
                },
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "ProcessCapacity",
                  "create",
                ),
                // disabled: true,
              },
            ],
          },
          columns: [
            {
              screenField: "StartDate",
              dataField: "DateStart",
              label: "Date",
              minWidth: ColumnWidth.Date.minWidth,
              width: ColumnWidth.Date.width,
              filterDataField: "DateStart",
              filterIndex: 1,
              filterLabel: "Date",
              sortIndex: 0,
              sortOrder: "desc",
            },
            {
              screenField: "ExceptionType",
              minWidth: 150,
              width: 150,
              calculateCellValue: (data) => {
                return data.ExceptionType === "Shift"
                  ? "Shift Exception"
                  : "Process Exception";
              },
              filterIndex: 0,
              filterLabel: "Exception Type",
              dataSourceConfig: {
                data: [
                  { key: "Shift", value: "Shift Exception" },
                  { key: "Process", value: "Process Exception" },
                ],
              },
              valueExpr: "key",
              displayExpr: "value",
            },
            {
              screenField: "ShiftExceptionReasonName",
              dataField: "ReasonShortCode",
              visible: true,
              cellTemplate: "Record",
              minWidth: 200,
              width: 200,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ReasonName",
                  },
                ],
                secondary: [
                  {
                    dataField: "ReasonShortCode",
                  },
                ],
              },
              filterIndex: 3,
              filterLabel: "Reason",
              filterDataField: "ReasonShortCode",
              dataSourceConfig: {
                endpoint: "api/ShiftExceptionReasonList",
                sort: {
                  selector: "Name",
                  asc: true,
                },
              },
              valueExpr: "ShortCode",
              displayExpr: "Name",
              editorTemplate: {
                primary: [
                  {
                    dataField: "Name",
                  },
                ],
                secondary: [
                  {
                    dataField: "ShortCode",
                  },
                ],
              },
            },
            {
              screenField: "Comments",
              label: "Description",
              dataField: "Comment",
              allowHiding: false,
              width: "auto",
              visible: true,
              type: "Text",
              filterLabel: "Comment",
            },
            {
              screenField: "Shift",
              dataField: "ShiftCode",
              filterIndex: 4,
              filterLabel: "Shift",
              minWidth: 200,
              width: 200,
              cellTemplate: "Record",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ShiftDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "ShiftCode",
                  },
                ],
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              filterDataField: "ShiftCode",
              dataSourceConfig: {
                endpoint: "api/ShiftList",
                sort: {
                  selector: "Code",
                  asc: true,
                },
              },
              valueExpr: "Code",
              displayExpr: "Description",
            },
            {
              screenField: "ProcessCount",
              width: 100,
              minWidth: 100,
            },
            {
              screenField: "ProcessList",
              gridDataField: "ProcessesList",
              filterDataField: "ProcessesList",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 5,
              filterOperator: "contains",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Remove Exception",
                      data: data,
                      clickAction: this.onRemoveExceptionHandler,
                    },
                  ];
                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission(
                  "ProcessCapacity",
                  "create",
                );
              },
            },
          ],
        },
      };
    },
  },
  created() {},
  methods: {
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.setLoading = value;
    },
    /**
     * On Row Click CallBack
     * @param e
     */
    // eslint-disable-next-line no-unused-vars
    async rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.ShowLoading(true);

        // Select the appropriate API method based on ExceptionType
        const apiMethod =
          e.data.ExceptionType === "Shift"
            ? ProcessCapacityService.getShiftExceptionByRecordId
            : ProcessCapacityService.getProcessShiftExceptionByRecordId;

        try {
          const response = await apiMethod(e.data.SourceRecordID);
          if (IsResponseDataValid(response)) {
            this.dataModel = response.data.value[0];
            this.dataModel.ExceptionType = e.data.ExceptionType;
            this.shiftExceptionPopupConfig.isPopupShow = true;
            this.shiftExceptionPopupConfig.formMode = "review";
            this.shiftExceptionPopupConfig.title =
              e.data.ExceptionType === "Shift"
                ? "Shift Exception"
                : "Process Shift Exception";
          }
        } catch (error) {
          this.displayServerError(error);
        } finally {
          this.ShowLoading(false);
        }
      }
    },
    async onRemoveExceptionHandler(e) {
      let confirm = await this.$confirm(
        "Are you sure to remove this exception?",
        "Confirmation",
      );

      if (confirm) {
        this.ShowLoading(true);

        const apiMethod =
          e.ExceptionType === "Shift"
            ? ProcessCapacityService.deleteShiftException
            : ProcessCapacityService.deleteProcessShiftException;
        await apiMethod(e.SourceRecordID._value)
          .then(() => {
            this.$refs["exception-list"].$refs[
              "transactionListGrid"
            ].gridRefresh();
            this.$notify("Exception has been deleted", "success");
            this.ShowLoading(false);
          })
          .catch(() => {
            this.$notify("Failed to delete.", "error");
            this.ShowLoading(false);
          });
      }
    },

    /*
     * Post Process Callback
     * @param data
     */
    postProcessCallback(data) {
      data.forEach((element) => {
        element.DisplayStartTime = this.timeStringToDate(element.StartTime);
        element.DisplayEndTime = this.timeStringToDate(element.EndTime);
      });

      return data;
    },

    /**
     * Normalize Time String
     * @param timeStr
     */
    normalizeTimeString(timeStr) {
      if (!timeStr) return null;

      const parts = timeStr.split(":");
      if (parts.length !== 2) return null;

      let [h, m] = parts;

      h = h.padStart(2, "0");
      m = m.padStart(2, "0");

      return `${h}:${m}`;
    },

    /**
     * Time String to Date
     * @param timeStr
     */
    timeStringToDate(timeStr) {
      const normalized = this.normalizeTimeString(timeStr);
      if (!normalized) return null;

      const [h, m] = normalized.split(":");
      const d = new Date();
      d.setHours(+h, +m, 0, 0);

      return d;
    },

    // Shift Note Popup Methods
    // eslint-disable-next-line no-unused-vars
    onShiftsPopupHide(repaint = true) {
      this.shiftExceptionPopupConfig.isPopupShow = false;
      this.dataModel = undefined;

      if (repaint) {
        this.$refs["exception-list"].$refs["transactionListGrid"].gridRefresh();
      }
    },

    onNewShiftExceptionHandler() {
      this.shiftExceptionPopupConfig.isPopupShow = true;
      this.shiftExceptionPopupConfig.formMode = "create";
      this.shiftExceptionPopupConfig.title = "Create New Exception";
    },

    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
  },
};
</script>

<style lang="scss">
.dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
  vertical-align: top !important;
}
</style>
